import React from "react";
import "./Pagination.css";

const PaginationControls = ({ page, totalPages, onPageChange, className }) => {
  if (totalPages <= 1) return null;

  const handleChange = (nextPage) => {
    if (nextPage < 1 || nextPage > totalPages || nextPage === page) return;
    onPageChange(nextPage);
  };

  const pages = (() => {
    if (totalPages <= 5) {
      return Array.from({ length: totalPages }, (_, idx) => idx + 1);
    }

    const start = Math.max(2, page - 1);
    const end = Math.min(totalPages - 1, page + 1);

    const items = [1];
    if (start > 2) items.push("ellipsis-start");

    for (let number = start; number <= end; number += 1) {
      items.push(number);
    }

    if (end < totalPages - 1) items.push("ellipsis-end");
    items.push(totalPages);

    return items;
  })();

  return (
    <div className={`pagination-container ${className || ""}`.trim()}>
      <button
        className="pagination-nav-btn"
        onClick={() => handleChange(1)}
        disabled={page === 1}
        aria-label="Первая страница"
      >
        <span className="pagination-icon">⏮</span>
      </button>
      <button
        className="pagination-nav-btn"
        onClick={() => handleChange(page - 1)}
        disabled={page === 1}
        aria-label="Предыдущая страница"
      >
        <span className="pagination-icon">◀</span>
      </button>

      <div className="pagination-pages">
        {pages.map((item, index) =>
          typeof item === "string" ? (
            <span key={item + index} className="pagination-ellipsis">
              ...
            </span>
          ) : (
            <button
              key={item}
              className={`pagination-page-btn ${
                item === page ? "pagination-page-btn--active" : ""
              }`}
              onClick={() => handleChange(item)}
              aria-label={`Страница ${item}`}
              aria-current={item === page ? "page" : undefined}
            >
              {item}
            </button>
          )
        )}
      </div>

      <button
        className="pagination-nav-btn"
        onClick={() => handleChange(page + 1)}
        disabled={page === totalPages}
        aria-label="Следующая страница"
      >
        <span className="pagination-icon">▶</span>
      </button>
      <button
        className="pagination-nav-btn"
        onClick={() => handleChange(totalPages)}
        disabled={page === totalPages}
        aria-label="Последняя страница"
      >
        <span className="pagination-icon">⏭</span>
      </button>
    </div>
  );
};

export default PaginationControls;
